var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M17,0 L17,15 L0,15 L0,0 L17,0 Z M15,9 L2,9 L2,13 L15,13 L15,9 Z M15,4 L2,4 L2,8 L15,8 L15,4 Z","fill-rule":"nonzero"}})])}
var staticRenderFns = []

export { render, staticRenderFns }